export default {
  headerGeneral: 'General properties',
  headerSimulationValues: 'Simulation values',
};
